import { useState, useRef, useEffect } from "react";

const STATUS_OPTIONS = ["Ordered", "Partially Received", "Received", "Closed / Invoiced"];
const STATUS_CLASSES = {
  "Ordered":             "pill-ordered",
  "Received":            "pill-received",
  "Partially Received":  "pill-partial",
  "Closed / Invoiced":   "pill-closed",
};

function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

function StatusPill({ status, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const current = status || "Ordered";
  return (
    <span ref={ref} style={{ position: "relative", display: "inline-block" }} onClick={(e) => e.stopPropagation()}>
      <span className={`pill ${STATUS_CLASSES[current] || "pill-ordered"}`} style={{ cursor: "pointer", userSelect: "none" }} onClick={() => setOpen((o) => !o)} title="Click to change status">
        {current}
        <i className="ti ti-chevron-down" style={{ fontSize: 11, marginLeft: 4, verticalAlign: -1 }} aria-hidden="true" />
      </span>
      {open && (
        <div className="status-dropdown">
          {STATUS_OPTIONS.map((s) => (
            <div key={s} className={`status-option${s === current ? " active" : ""}`} onClick={() => { onChange && onChange(s); setOpen(false); }}>
              <span className={`pill ${STATUS_CLASSES[s]}`}>{s}</span>
            </div>
          ))}
        </div>
      )}
    </span>
  );
}

export default function StatusView({ status, pos, loading, onSelect, selectedPO, onStatusChange }) {
  if (loading) return <div className="state-box"><div className="spinner" /><p>Loading {status} POs…</p></div>;
  if (!pos.length) return <div className="state-box"><i className="ti ti-circle-check" aria-hidden="true" /><p>No {status} purchase orders</p></div>;

  return (
    <>
      <div className="list-header status-view-header">
        <div>Document</div><div>Vendor</div><div>Modified</div><div>Status</div><div />
      </div>
      {pos.map((po) => {
        const rowStatus = po.fields?.Status || "Ordered";
        return (
          <div key={po.id} className={`po-row status-view-row${selectedPO?.id === po.id ? " selected" : ""}`} onClick={() => onSelect(po)}>
            <div className="po-filename">
              <i className="ti ti-file-type-pdf pdf-icon" aria-hidden="true" />
              <span title={po.name}>{po.name}</span>
            </div>
            <div style={{ fontSize: 13, color: "var(--text2)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{po.vendorName}</div>
            <div className="po-date">{fmtDate(po.lastModifiedDateTime)}</div>
            <div onClick={(e) => e.stopPropagation()}>
              <StatusPill status={rowStatus} onChange={(s) => onStatusChange && onStatusChange(po.id, s, po)} />
            </div>
            <div />
          </div>
        );
      })}
    </>
  );
}
